import React from 'react';
import {
  Container,
  Grid,
  makeStyles
} from '@material-ui/core';
import Page from '../../../components/Page';
import ReportForm from './ReportForm';

import parseUrl from '../../../utils/parseUrl';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const ReportFormPage = () => {
  const classes = useStyles();

  const reportId = parseUrl(3);

  return (
    <Page
      className={classes.root}
      title="Отчёт"
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={3}
        >
          <ReportForm reportId={reportId} />
        </Grid>
      </Container>
    </Page>
  );
};

export default ReportFormPage;
